export default {
    initialize(config) {
        this.config = config;
    },

    setDIEnvConfig(dIEnvConfigParam) {
        this.dIEnvConfig = dIEnvConfigParam;
    },
};
